<template>
  <footer>
    <p>Copyright &copy; {{ year }} Leightons Opticians &amp; Hearing Care. All Rights Reserved.</p>
  </footer>
</template>

<script>
export default {
  name: "PageFooter",
  computed: {
    year() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style lang="postcss" scoped>
footer {
  @apply flex h-[180px] w-full px-[30px] sm:px-0 py-4 items-center content-center sm:text-center bg-black uppercase justify-center;

  p {
    @apply text-white text-xs;
  }
}
</style>